import { Options } from '@shared/ui/components/Select';

export type CertificateType = 'driversLicense' | 'safetyCertificate' | 'other';

export const certificateTypeOptions: Options<CertificateType> = [
  { value: 'driversLicense', label: "Driver's License" },
  { value: 'safetyCertificate', label: 'Safety Certificate' },
  { value: 'other', label: 'Other' },
];
